import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon, StarIcon, TrophyIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE_FULL, PRICE_SHORT, Section, trackCheckoutClick } from './Shared';
import { DnaHelix, Mandala } from './BioDecor';
function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 53,
    s: 58
  });
  const spotsTaken = 75;
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(current => {
      const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
      return {
        h: Math.floor(seconds / 3600),
        m: Math.floor(seconds % 3600 / 60),
        s: seconds % 60
      };
    }), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-190" data-mp="2kc3qw3zvgatw">
      <div className="min-w-[58px] rounded-xl bg-brand-blue px-3 py-2 font-mono text-2xl font-bold tabular-nums text-brand-goldLight ring-1 ring-brand-gold/40 md:min-w-[80px] md:px-5 md:py-3 md:text-4xl" data-id="element-191" data-mp="12sj4kz5km3a0">
        {format(value)}
      </div>
      <span className="mt-1.5 text-[10px] font-semibold uppercase tracking-wider text-brand-muted md:text-sm" data-id="element-192" data-mp="1cjdtyce45izo">
        {label}
      </span>
    </div>;
  return <div className="mx-auto mb-12 max-w-4xl" data-id="element-193" data-mp="1mefip74h8j1q">
      <div className="paper-panel rounded-3xl border-2 border-brand-gold/40 p-6 md:p-8" data-id="element-194" data-mp="1mhbh0wk8l9qp">
        <div className="mb-5 flex items-center justify-center gap-2" data-id="element-195" data-mp="1hii2d0t7rcoy">
          <ClockIcon className="h-5 w-5 text-brand-goldDark" data-id="element-196" data-mp="1vevl0d9hhk50" />
          <h3 className="font-serif text-base font-bold text-brand-blue md:text-xl" data-id="element-197" data-mp="1qhbx0lmzhszv">
            ⏰ PRECIO ESPECIAL DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>
        <div className="mb-5 flex items-center justify-center gap-2 md:gap-4" data-id="element-198" data-mp="13yxratqav5m">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-199" data-mp="3sa9rsn0bmvng" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-200" data-mp="1w5tw76fut5ls">:</span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-201" data-mp="214dmfj1hd3jy" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-202" data-mp="2156kzwqacmr0">:</span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-203" data-mp="2638dt9dik0fo" />
        </div>
        <div className="mb-6 flex items-center justify-center gap-2 rounded-xl border border-brand-gold/50 bg-brand-goldLight/40 px-4 py-3" data-id="element-204" data-mp="265ui9053xzto">
          <AlertTriangleIcon className="h-5 w-5 shrink-0 text-brand-goldDark" data-id="element-205" data-mp="2f34xsxoykb4e" />
          <p className="text-center text-sm font-semibold text-brand-text md:text-base" data-id="element-206" data-mp="2k2pv73ohcbf0">
            Después sube. <span className="text-brand-greenMid" data-id="element-207" data-mp="2otg42qw46weg">Pago único, sin mensualidades.</span>
          </p>
        </div>
        <div className="rounded-2xl border border-brand-blue/15 bg-white p-4 md:p-5" data-id="element-208" data-mp="2ts11kijzf1z7">
          <div className="mb-3 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between" data-id="element-209" data-mp="2xvfj5dnkjqer">
            <span className="flex items-center gap-2 text-sm font-semibold text-brand-text md:text-base" data-id="element-210" data-mp="32sz9hbxjjtn2">
              <span className="relative flex h-2.5 w-2.5" data-id="element-211" data-mp="r7gkzonhefsl">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-amber opacity-75" data-id="element-212" data-mp="m7ap1wa6i74p" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-brand-amber" data-id="element-213" data-mp="i57cf4brwwhu" />
              </span>
              Accesos al precio de lanzamiento
            </span>
            <span className="text-xs font-bold uppercase tracking-wide text-brand-goldDark" data-id="element-214" data-mp="19wvi5801qkrp">Quedan pocos</span>
          </div>
          <div className="mb-2 h-2.5 w-full overflow-hidden rounded-full bg-brand-blue/10" data-id="element-215" data-mp="15v1o3ikcwf0i">
            <div className="h-full rounded-full bg-brand-greenMid" style={{
            width: `${spotsTaken}%`
          }} data-id="element-216" data-mp="1141tijypm916" />
          </div>
          <p className="text-center text-xs text-brand-muted md:text-sm" data-id="element-217" data-mp="w58cihk7rzw9">
            <strong className="text-brand-greenMid" data-id="element-218" data-mp="1tlxjsqrxnud1">{spotsTaken}%</strong> de los accesos al precio de lanzamiento ya
            tomados
          </p>
        </div>
      </div>
    </div>;
}
function Pricing() {
  return <Section id="comprar" glow className="my-12 rounded-3xl border border-brand-gold/45 bg-brand-parchment" data-id="element-219" data-mp="18d3f9awdqfyb">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden rounded-3xl" data-id="element-220" data-mp="1df154nzac908">
        <Mandala className="absolute left-6 top-8 h-20 w-20 text-brand-blueMist" data-id="element-221" data-mp="zg1e59oavi0w" />
        <DnaHelix className="absolute bottom-6 right-8 hidden h-40 w-20 text-brand-greenSoft/25 md:block" data-id="element-222" data-mp="14dbg1osvlm5m" />
      </div>

      <div className="relative mb-10 text-center" data-id="element-223" data-mp="1s501cl7a5ad2">
        <span className="animate-glow-pulse mb-4 inline-flex items-center gap-2 rounded-full bg-brand-blue px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-brand-goldLight md:text-sm" data-id="element-224" data-mp="1w364zkctn9tr">
          🧬 Oferta especial Latinoamérica
        </span>
        <h2 className="font-display text-3xl font-bold text-brand-blue md:text-4xl" data-id="element-225" data-mp="2b1i37vfueqn1">
          TU <span className="text-brand-goldDark" data-id="element-226" data-mp="2azncu1lsy6bk">KIT MAESTRO DE BIODESCODIFICACIÓN™</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-brand-greenMid md:text-base" data-id="element-227" data-mp="2fu1h6tifznsd">
          Pago único · Sin mensualidades · El valor se adapta a tu moneda local
        </p>
      </div>

      <div className="mx-auto max-w-2xl space-y-5" data-id="element-228" data-mp="2l3c8egb4xc4e">
        <div className="relative rounded-3xl" data-id="element-229" data-mp="2yvs4ex5mc9vt">
          <span className="glow-frame" aria-hidden="true" data-id="element-230" data-mp="2yyxx0mdghtwa" />
          <div className="relative z-10 rounded-3xl bg-white p-6 shadow-lg md:p-8" data-id="element-231" data-mp="2tz1pid5jvkbz">
            <div className="mb-3 flex items-center gap-1.5 text-brand-goldDark" data-id="element-232" data-mp="267e7kkq9njlu">
              <TrophyIcon className="h-4 w-4 fill-current" data-id="element-233" data-mp="226ublkhfim1a" />
              <StarIcon className="h-4 w-4 fill-current" data-id="element-234" data-mp="228nhuyo4r48r" />
              <span className="text-[10px] font-bold uppercase tracking-wider md:text-sm" data-id="element-235" data-mp="2g7de6c34kzw2">
                Disponible en toda Latinoamérica
              </span>
            </div>
            <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-236" data-mp="3rkze8saiwlwd">
              <div className="max-w-md" data-id="element-237" data-mp="3rnbqqpxii421">
                <h3 className="font-serif text-lg font-bold text-brand-blue md:text-xl" data-id="element-238" data-mp="3mlcpbllc1h7q">
                  🏆 KIT MAESTRO DE BIODESCODIFICACIÓN™
                </h3>
                <p className="mt-1 text-sm text-brand-muted" data-id="element-239" data-mp="2jb5d8b1q3f8">3 Tomos + 5 Bonus · Más de 150 páginas</p>
                <p className="mt-2 text-sm font-medium leading-relaxed text-brand-greenMid" data-id="element-240" data-mp="7inopj2pksd2">
                  Protocolos, preguntas de exploración, prácticas de integración, fichas y documentación
                  profesional, todo en un solo sistema.
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-241" data-mp="3fy7fmbfwpyoy">
                <p className="text-xs uppercase tracking-wide text-brand-muted" data-id="element-242" data-mp="3fyqwdottmh1e">Valor de referencia</p>
                <p className="text-lg text-brand-muted line-through" data-id="element-243" data-mp="3kvpra9lb6s0n">{PRICE_FULL}</p>
                <p className="mt-1 text-xs uppercase tracking-wide text-brand-muted" data-id="element-244" data-mp="3posm0l1to7if">Hoy</p>
                <p className="font-serif text-4xl font-bold text-brand-greenMid md:text-5xl" data-id="element-245" data-mp="2s7lj9hf9m2us">{PRICE_SHORT}</p>
                <p className="text-xs text-brand-muted" data-id="element-246" data-mp="2x6evl6itfntd">Pago único — El valor se adapta a tu moneda local</p>
              </div>
            </div>
          </div>
        </div>

        <motion.a href={CHECKOUT_URL} onClick={trackCheckoutClick} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.98
      }} transition={{
        duration: 0.14,
        ease: [0.23, 1, 0.32, 1]
      }} className="cta-shimmer relative flex w-full justify-center overflow-hidden rounded-full bg-brand-blue px-6 py-5 text-center text-base font-bold text-brand-goldLight shadow-[0_12px_28px_rgba(8,32,60,.28)] ring-1 ring-brand-gold/50 md:text-xl" data-id="element-247" data-mp="2koud54ru9in5">
          <span className="relative z-10" data-id="element-248" data-mp="1wzjafhqxhe6d">→ QUIERO MI KIT MAESTRO POR {PRICE_SHORT}</span>
        </motion.a>

        <div className="grid gap-3 rounded-2xl bg-brand-sageMist/70 p-4 text-center sm:grid-cols-5" data-id="element-249" data-mp="1s0osei0sbtnb">
          {['📥 Acceso inmediato', '💱 El valor se adapta a tu moneda local', '📱 100% digital', '🛡️ Garantía 7 días', '🔐 Pago seguro'].map(item => <span key={item} className="text-xs font-bold text-brand-greenMid" data-id="element-250" data-mp="1j11rdxbywpus">
                {item}
              </span>)}
        </div>
      </div>
    </Section>;
}
export function LaunchOffer() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-251" data-mp="3bv10h6e3rh00">
      <LaunchUrgency data-id="element-252" data-mp="2wz1v43idnuyk" />
      <Pricing data-id="element-253" data-mp="2wxh1qh7sui2a" />
    </div>;
}